import { Button, Col, Form, message, Modal, Popconfirm, Row, Table, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import {
	DatePickerWithMask,
    UIPageListing,
} from "../../../components";
import moment from "moment";
import { timeCardService } from "../../../redux/services";

const ModalListSigned = ({
    visible,
    onClose,
    empresa_id,
    funcionario_id,
    data_inicial,
    data_final
}) => {
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState([]);
    const [pagination, setPagination] = useState({
      current: 1,
      pageSize: 10,
      total: 0,
    });

    const fetchData = ({ current, pageSize }) => {
        setIsLoading(true);

        timeCardService.listarCartoesAssinados({
            empresa_id,
            funcionario_id,
            data_inicio: moment(data_inicial).format('YYYY-MM-DD'),
            data_fim: moment(data_final).format('YYYY-MM-DD'),
            paginacao: pageSize,
            page: current,
        }).then(({ data }) => {
            setData(data.data);
            setPagination({
                ...pagination,
                total: data.total,
                current,
                pageSize,
            })
            setIsLoading(false);
        }).catch((data) => {
            console.log('error', data);
            message.error('Ocorreu um erro ao listar as assinaturas, tente novamente!');
            setIsLoading(false);
        });
    }

    const cancelarSolicitacaoAssinatura = (solicitacao_id) => {
        setIsLoading(true);

        timeCardService.cancelarSolicitacaoAssinatura({
            solicitacao_id,
            funcionario_id,
        }).then(({ data }) => {
            setIsLoading(false);
            message.success('Solicitação cancelada!');
            fetchData(pagination);
        }).catch((data) => {
            message.error('Ocorreu um erro ao cancelar a solicitação de assinatura, tente novamente!');
            setIsLoading(false);
        });
    }

    const deleteSignature = (uuid) => {
      setIsLoading(true);

      timeCardService.excluirSolicitacaoAssinatura({
          uuid,
      }).then(({ data }) => {
          setIsLoading(false);
          message.success('Assinatura excluida!');
          fetchData(pagination);
      }).catch((data) => {
          Modal.error({
              title  : "Ocorreu um erro!",
              content: String(data),
          });
          setIsLoading(false);
      });
    }

    const onPaginationChange = (paginationData) => {
        fetchData({ current: paginationData.current, pageSize: paginationData.pageSize });
	};

    const onCloseModal = () => {
        if (onClose) onClose();
    }

    useEffect(() => {
        if (visible) fetchData({ current: pagination.current, pageSize: pagination.pageSize });
    }, [visible]);

    const statusTipo = {
        signed: 'Assinado',
        pending: 'Pendente',
        canceled: 'Cancelada',
    }

    const columns = [
      {
        title: "Data inicio",
        dataIndex: "data_inicio",
        render: (date) => moment(date).format("DD/MM/YYYY"),
      },
      {
        title: "Data fim",
        dataIndex: "data_fim",
        render: (date) => moment(date).format("DD/MM/YYYY"),
      },
      {
        title: "Status",
        dataIndex: "status_assinatura",
        render: (status) => statusTipo[status],
      },
      {
        title: "Data assinatura",
        dataIndex: "assinado_em",
        render: (date) =>
          date ? moment(date).format("DD/MM/YYYY HH:mm") : "-",
      },
      {
        title: "",
        width: 40,
        dataIndex: "url_pdf",
        render: (url, data) => (
          <Row>
            {data.assinado_em && (
              <Col span={12}>
                <Tooltip title="Baixar cartão assinado">
                  <Button type="link" href={url}>
                    <i class="fas fa-download"></i>
                  </Button>
                </Tooltip>
              </Col>
            )}
            {!(['canceled', 'signed'].includes(data.status_assinatura)) && (
              <Col span={12}>
                  <Tooltip title="Cancelar solicitação de assinatura">
                    <Popconfirm
                      placement="topRight"
                      title="Deseja cancelar essa solicitação?"
                      onConfirm={() => cancelarSolicitacaoAssinatura(data.id)}
                      okText="Sim"
                      cancelText="Não"
                    >
                      <Button type="link" style={{ color: "#6B7280" }}>
                        <i class="fas fa-ban"></i>
                      </Button>
                    </Popconfirm>
                  </Tooltip>
              </Col>
              )}
            {!(['signed'].includes(data.status_assinatura)) && (
              <Col span={12}>
                  <Tooltip title="Excluir solicitação de assinatura">
                    <Popconfirm
                      placement="topRight"
                      title="Deseja excluir essa solicitação?"
                      onConfirm={() => deleteSignature(data.uuid)}
                      okText="Sim"
                      cancelText="Não"
                    >
                      <Button type="link" style={{ color: "red" }}>
                        <i class="fas fa-trash"></i>
                      </Button>
                    </Popconfirm>
                  </Tooltip>
              </Col>
              )}
          </Row>
        ),
      },
    ];

    return (
      <Modal
        visible={visible}
        title="Cartões Ponto enviado para assinatura"
        wrapClassName="modal-scroll"
        destroyOnClose={true}
        maskClosable={false}
        width={580}
        onCancel={onCloseModal}
        onOk={onCloseModal}
        closable={true}
        centered
      >
        <Table
          className="table-detalhe-batida"
          loading={{
            spinning: isLoading,
            indicator: <i className="fad fa-spinner-third fa-spin fa-2x" />,
          }}
          rowKey="uuid"
          locale={{ emptyText: "Nenhuma solicitação de assinatura enviada." }}
          columns={columns}
          dataSource={data ?? []}
          pagination={pagination}
          onChange={onPaginationChange}
        />
      </Modal>
    );
}

export default ModalListSigned;